module.exports = __webpack_public_path__ + "img/Img_1.020ed411.jpg";